export default __webpack_public_path__ + "static/media/AllrfpDarkActive.4e15f5cd.svg";